/**
 * Module-level open/close state for the developer record-test sheet.
 *
 * The voice scaffold (record → process → diagnose) used to live in
 * the Me tab. It's a dev-only tool now — useful for verifying audio
 * and summarization end-to-end, but not part of the real product.
 * Accessing it from the Voice Diagnostics modal keeps the Me tab
 * free to become a user-facing surface.
 *
 * Mirrors useTheme / useDeveloperMode — module singleton + sync
 * external store — so only components that subscribe re-render
 * on toggle.
 */
import { useSyncExternalStore } from "react";

let open = false;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot() {
  return open;
}

export function setDevRecordScreenOpen(next: boolean) {
  open = next;
  listeners.forEach((fn) => fn());
}

export function useDevRecordScreen() {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
